import { ref, useContext, useRoute } from '@nuxtjs/composition-api'
import _get from 'lodash/get'
import useDownload from './useDownload'
import { assembleUrl } from '@/utils/url'

export default function useDocumentsDownload(documentType = 'course') {
  const { store = {} } = useContext()
  const route = useRoute()
  const isDownloadingDocument = ref(false)
  const school = _get(store, 'state.settings.school')
  const activeCatalog = _get(store, 'state.settings.activeCatalog')

  const { download } = useDownload()

  async function downloadDocument(documentId) {
    if (!school || !activeCatalog || !documentId) return
    const downloadPdfUrl = `/ca/${school}/catalogs/${activeCatalog}/${documentType}s/${documentId}/version-pdf`
    const hasEffectiveDatesRange = route.value?.query?.effectiveDatesRange
    const queryParams = hasEffectiveDatesRange  ? {
      noAutoGeneratedCards: 'true',
      removeContentHyperlinks: 'true',
      includeRevisionInTitle: 'true',
    } : {} 
    
    try {
      isDownloadingDocument.value = true
      await download({
        url: assembleUrl(downloadPdfUrl, queryParams),
        filename: `${documentType}-${documentId}.pdf`,
      })
    } catch (e) {
      console.error(e)
    } finally {
      setTimeout(() => {
        isDownloadingDocument.value = false
      }, 200)
    }
  }

  return {
    downloadDocument,
    isDownloadingDocument,
  }
}
